import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { Page, Pane, PaneBackButton, PaneBody } from '../../atoms/applications/page';
import './multicreatorPackageSelectionPane.module.scss';
import { ApplicationPaneHeader } from '../../atoms/applications/ApplicationPaneHeader';
import { MulticreatorApplicationPageState } from '../../../containers/application/states/MulticreatorApplicationPageState';
import { MulticreatorPackageCard } from '../multicreator_package/MulticreatorPackageCard';
import { Button } from '../../../../commonv3/components/atoms/buttons/Button';
import { PackagePlanSelector } from '../multicreator_package/PackagePlanSelector';
import { Warning } from '../../atoms/membership_plans/Warning';
import { SpBr } from '../../../../commonv3/components/atoms/layouts/br';

type Props = {
    applicationState: MulticreatorApplicationPageState;
};

export const MulticreatorSessionAttention = () => (
    <div styleName="warning_wrapper">
        <Warning>
            プランの各日程は、予約確定後の変更・キャンセルができません。<SpBr />日時をよく確認いただいた上でご予約ください。
        </Warning>
    </div>
);

@inject('applicationState')
@observer
export class MulticreatorPackageSelectionPane extends React.Component<Props> {
    render() {
        const {
            name,
            canGoBack,
            selectablePackagePlans,
            selectablePackages,
            selectedPackageId,
            setSelectedPackageId,
            validatePackageAndNext,
            selectableFinalReviewSessions,
            selectableInitialCoachingSessions,
            selectableIntermediateReviewSessions,
            selectedFinalReviewSessionId,
            selectedIntermediateReviewSessionId,
            selectedInitialCoachingSessionId,
            setSelectedFinalReviewSessionId,
            setSelectedIntermediateReviewSessionId,
            setSelectedInitialCoachingSessionId,
            packageAndSessionsSelected,
            selectedPackagePlanId,
            setSelectedPackagePlanId,
        } = this.props.applicationState;
        return (
            <Page>
                <Pane styleName="pane">
                    {canGoBack && <PaneBackButton />}
                    <ApplicationPaneHeader plan={name} />
                    <PaneBody>
                        <div styleName="plan-selector-wrapper">
                            <PackagePlanSelector
                                packagePlans={selectablePackagePlans}
                                selectedPackagePlanId={selectedPackagePlanId}
                                onSelect={setSelectedPackagePlanId}
                            />
                        </div>
                        <MulticreatorSessionAttention />
                        {selectablePackages.map((p) => (
                            <MulticreatorPackageCard
                                key={p.id}
                                multicreatorPackage={p}
                                initialCareerCoachingSessions={selectableInitialCoachingSessions}
                                finalReviewSessions={selectableFinalReviewSessions}
                                intermediateReviewSessions={selectableIntermediateReviewSessions}
                                selectedFinalReviewSessionId={selectedFinalReviewSessionId}
                                selectedInitialCoachingSessionId={selectedInitialCoachingSessionId}
                                selectedIntermediateReviewSessionId={selectedIntermediateReviewSessionId}
                                selectFinalReviewSession={setSelectedFinalReviewSessionId}
                                selectInitialCoachingSession={setSelectedInitialCoachingSessionId}
                                selectIntermediateReviewSession={setSelectedIntermediateReviewSessionId}
                                onSelect={() => setSelectedPackageId(p.id)}
                                selected={p.id === selectedPackageId}
                            />
                        ))}
                        <div styleName="button-wrapper">
                            <Button
                                id="submit-button"
                                type="primary"
                                onClick={validatePackageAndNext}
                                styleName="button"
                                disabled={!packageAndSessionsSelected}
                            >
                                パッケージを選択する
                            </Button>
                        </div>
                    </PaneBody>
                </Pane>
            </Page>
        );
    }
}
